export const resolvePerspectiveConfig = (
  perspectiveConfigurations: any[],
  perspectiveKey: string
) => {
  let perspectiveConfig = perspectiveConfigurations.find((config: any) => config.key === perspectiveKey);
  if (perspectiveKey === 'trend' && !perspectiveConfig) {
    perspectiveConfig = {
      key: 'trend',
      label: 'Trend over time',
      fieldPath: 'trend',
    };
  }
  return perspectiveConfig;
};

export const transformPerspectiveCountResponse = (
  perspectiveKey: string,
  perspectiveConfig: any,
  perspectiveCountResponse: any
) => {
  if (perspectiveKey === 'trend' && perspectiveCountResponse?.trendData) {
    return {
      trendData: perspectiveCountResponse.trendData,
      dataArr: perspectiveCountResponse.trendData['All'] || [],
      total: perspectiveCountResponse?.total || 0,
      title: 'Trend over time',
      isTrendPerspective: true,
    };
  }
  return {
    dataArr: perspectiveCountResponse?.counts || [],
    total: perspectiveCountResponse?.total || 0,
    requestsCount: perspectiveCountResponse?.counts?.reduce(
      (sum: number, item: any) => sum + (item.requestsCount || 0),
      0
    ) || 0,
    matchesCount: perspectiveCountResponse?.counts?.reduce(
      (sum: number, item: any) => sum + (item.matchesCount || 0),
      0
    ) || 0,
    title: perspectiveConfig.label || perspectiveConfig.key,
  };
};
